import React from "react";
import { Grid } from "@mui/material";
import Table from "../../../subcomponents/Table";
import { Card } from "../styled";

const style = {
  justify: "center",
};

const rejectionColumns = [
  {
    id: "motivoRejeicao",
    name: "Motivo de Rejeição",
    style: { ...style },
  },
  {
    id: "contrapartida",
    name: "Contrapartida",
    style: { ...style },
  },
];

export const RejectionReasonsSection = ({ opinions = [] }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Card>
          <Table
            loadingRows={5}
            noDataMessage="Sem dados"
            columns={rejectionColumns}
            loading={false}
            entries={opinions}
            // Sem onRowClick nem selectedRow
          />
        </Card>
      </Grid>
    </Grid>
  );
};
